/**
 * Expected to match Scala validation:
 * import com.wixpress.accord.FormatValidators
 * FormatValidators.validEmail(email).isSuccess
 */

const anyLetter = '\u00A1-\uD7FF\uE000-\uFFFF-a-zA-Z';
const anyDigit = '0-9';
const anyLetterOrDigit = `${anyLetter}${anyDigit}`;
const anyAllowedSymbol = "!#$%&'*+/=?^_`{|}~-";
const allowedWithoutQuotes = `[${anyLetterOrDigit}${anyAllowedSymbol}]+(?:\\.[${anyLetterOrDigit}${anyAllowedSymbol}]+)*`;
const allowedBetweenQuotes = `(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*`;

const localPart = `(?:${allowedWithoutQuotes}|${allowedBetweenQuotes})`;
const domainPart =
  `(?:[${anyLetterOrDigit}](?:[${anyLetterOrDigit}-]*[${anyLetterOrDigit}])?\\.)+` +
  `(?:(?:[${anyDigit}]+[${anyLetter}][${anyLetterOrDigit}]*)|(?:[${anyLetter}][${anyLetterOrDigit}]{1,}))`;
export const emailValidationPattern = '^' + localPart + '@' + domainPart + '$';
